import React from 'react'
import PropTypes from 'prop-types'
import { P, H2, Section } from '../Globals/index.style'
import Button from './Button'
import { Grid, GridItem } from '@chakra-ui/react'
import { ContentWrapper, CTAWrapper } from './style'

const CallToAction = ({
  title,
  descriptions,
  primaryButton,
  center,
  isEnable,
}) => {
  return (
    <CTAWrapper isEnable={isEnable}>
      <ContentWrapper center={center}>
        {title && <H2>{title}</H2>}
        {descriptions && <P>{descriptions}</P>}
        <Button
          fullWidth={['sm']}
          href={primaryButton.href || primaryButton.to}
          text={primaryButton.text}
          to={primaryButton.to || primaryButton.href}
        ></Button>
      </ContentWrapper>
    </CTAWrapper>
  )
}

CallToAction.propTypes = {
  title: PropTypes.string,
  descriptions: PropTypes.string,
  center: PropTypes.string,
  isEnable: PropTypes.bool,
  primaryButton: PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string,
    to: PropTypes.string,
  }),
}

export default CallToAction
